import React from "react";
import { NavLink } from "react-router-dom";

const WebSalesLayout = ({ children }) => {
  const chosen =
    "py-2 px-3 mr-2 rounded-md text-blue-600 bg-blue-50";
  const notChosen = "py-2 px-3 mr-2 hover:text-blue-500";

  return (
    <div className="text-black bg-gray-100 pt-2 pb-1">
      <div className="mt-8 mb-12 mx-8 pt-4 px-12 text-black bg-white rounded-lg border">
        <div className="py-4 -mx-2 text-2xl font-medium">Web Sales</div>
        <div className="flex flex-row -mx-2 mt-4 mb-6 text-sm text-black w-full">
          <NavLink
            strict={false}
            to={`/sales/websales/view`}
            activeClassName={chosen}
            className={notChosen}
          >
            <p>Web Sales</p>
          </NavLink>
          <NavLink
            exact
            strict
            to={`/sales/websales/history/`}
            activeClassName={chosen}
            className={notChosen}
          >
            <p>History</p>
          </NavLink>
        </div>
        <div className="pb-8">{children}</div>
      </div>
    </div>
  );
};

export default WebSalesLayout;
